/**
 * Pollinator's partner organizations as the design lists them, locations and
 * all.
 *
 * The published lists come from the database: the page previews the
 * organizations staff have marked as featured, and the panel behind "here"
 * lists every organization in the network. This transcription stands in if
 * those cannot be fetched or nothing has been featured yet.
 */
export type PartnerOrganization = {
  name: string;
  location?: string | null;
};

export const marketingPartnerOrganizationsData: PartnerOrganization[] = [
  { name: "A Blade of Grass", location: "US" },
  { name: "AFIELD", location: "BELGIUM, FRANCE" },
  { name: "Art Omi", location: "US" },
  { name: "Artists Thrive", location: "US" },
  { name: "Arts University Plymouth", location: "UK" },
  { name: "Assets for Artists", location: "US" },
  { name: "at Louis Place", location: "US" },
  { name: "CEC ArtsLink", location: "INTERNATIONAL" },
  { name: "Charlotte Street", location: "US" },
  { name: "Concordia University", location: "CANADA" },
  { name: "Cooper Union", location: "US" },
  { name: "Core Residency Program", location: "US" },
  { name: "Creative Wildfire", location: "US" },
  { name: "EAT: Economics. Art. Transformation", location: "US" },
  { name: "Flux Factory", location: "US" },
  { name: "Fractured Atlas", location: "US" },
  { name: "Grand Central Art Center", location: "US" },
  { name: "Hayama Artist Residency", location: "JAPAN" },
  { name: "IndieSpace", location: "US" },
  { name: "Jerome Foundation", location: "US" },
  { name: "Just Tech Fellowship", location: "US" },
  { name: "Laundromat Project", location: "US" },
  { name: "LIFT Economy", location: "US" },
  { name: "MdW Coalition", location: "US" },
  { name: "Media Economies Design Lab", location: "US" },
  { name: "Miriam Gallery", location: "US" },
  { name: "More Art", location: "US" },
  { name: "NEW INC", location: "US" },
  { name: "Ox-Bow School of Art & Artists' Residency", location: "US" },
  { name: "Pioneer Works", location: "US" },
  { name: "Processing Foundation", location: "US" },
  { name: "Rhode Island School of Design", location: "US" },
  { name: "SAVVY Contemporary", location: "GERMANY" },
  { name: "Set Margins' Publications", location: "NETHERLANDS" },
  { name: "Small School", location: "US" },
  { name: "The Bronx Museum", location: "US" },
  { name: "The Strange Foundation", location: "US" },
  { name: "Tenthaus Art Collective", location: "NORWAY" },
  { name: "Traveling University", location: "SPAIN, GERMANY, SOUTH KOREA" },
  { name: "UCLA-DMA", location: "US" },
  { name: "University of North Carolina", location: "US" },
  { name: "University of Applied Arts Vienna", location: "AUSTRIA" },
];
